import React, { lazy } from 'react';

import { useNavigateToPrevious } from '#/lib/redirect';

const DepositModal = lazy(() => import('./DepositModal'));

function DepositMobilePage() {
  const navigateToPrevious = useNavigateToPrevious('/wallet/menu-mobile');
  return <DepositModal onClose={navigateToPrevious} />;
}

export default DepositMobilePage;
